import React from 'react';

// Approved copy for the Assets by Applicable Regulation chart (AB#17116 AC 8,
// added 2026-09-24). Source of truth: Confluence "Compliance Center — Table-Level
// Descriptions & Calc Guides", section T0 — both blocks render VERBATIM; where this
// file and that page differ, the page wins. The table line sits under the chart
// title; the calc guide fills the modal opened by a single click on the info icon
// (no hover tooltip — product direction, 17116 round 2).

export const CHART_TABLE_LINE = (
    <>
        Count of refrigerant-containing mechanical assets across your portfolio that meet the
        minimum requirement for one, or more than one, US-based Federal or State regulation.
        An asset can appear under more than one regulation, so <b>counts may overlap based on
        coverage</b> and will not necessarily sum to your total asset count. Select a regulation
        to see its obligations.
    </>
);

export const CHART_CALC_GUIDE = [
    {
        lead: 'How we decide:',
        text: 'each bar counts the assets carrying that regulation’s applicability tag, recalculated daily.',
    },
    {
        lead: 'Needs attention vs Compliant:',
        text: 'an asset counts as needs attention when it carries a Near or Hit status on at least one of that '
            + 'regulation’s obligation surfaces, however many it carries. Compliant is the remainder of the bar. '
            + 'Healthy statuses are never counted or shown.',
    },
    {
        lead: 'What is counted:',
        text: 'refrigerant-containing mechanical assets only — refrigeration, comfort cooling and process '
            + 'cooling equipment. Leak monitoring devices and refrigerant cylinders are not included in any '
            + 'regulation’s total. Where a regulation requires a monitoring device to be calibrated, the device '
            + 'appears on that regulation’s ALD Calibration tile, not in this chart.',
    },
    // AB#17309 AC 5: in-window population clause, verbatim, directly after "What is counted".
    {
        lead: 'Which assets are counted:',
        text: 'equipment in service, and equipment that is temporarily inactive or offline (seasonal, '
            + 'provisional or mothballed). Equipment that has been retired, removed or sold stays in the count '
            + 'until June 30 of the year after it left service, so it is still here while that year’s reports are '
            + 'filed. After that it drops off this page. Its records and history stay in Trakref.',
    },
    {
        lead: 'Federal vs. State:',
        text: 'the federal bars (EPA 608, EPA AIM Act) count assets across your US locations; a state bar is '
            + 'limited to that state, so the two aren’t directly comparable.',
    },
    {
        lead: 'Reading the lengths:',
        text: 'bar length reflects how wide each rule’s scope is, not how much risk you carry — EPA 608 '
            + 'covers only Class I and Class II (ozone-depleting) refrigerants, so it’s often one of the smaller '
            + 'bars and shrinking as those refrigerants are retired, while the AIM Act covers HFCs at a 15 lb floor '
            + 'and is usually one of the largest.',
    },
    {
        lead: 'Why counts overlap:',
        text: 'a California store with an ODS refrigeration system is in scope for EPA 608 and CA CARB; both bars '
            + 'count it.',
    },
    {
        lead: 'What to do:',
        text: 'start with the regulation where you have the most assets, or the one with an open obligation.',
    },
];
